import { RegionCreatableInterface } from '../interfaces/region-creatable.interface';
import { RegionDto } from './region.dto';
import {
  ApiPropertyOptional,
  IntersectionType,
  PartialType,
  PickType,
} from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import {
  ArrayMaxSize,
  IsArray,
  IsOptional,
  ValidateNested,
} from 'class-validator';
import { RegionTimeWindowSeedDto } from '../../region-time-window/dtos/region-time-window-seed.dto';

export class RegionCreateDto
  extends IntersectionType(
    PickType(RegionDto, [
      'name',
      'repairsRate',
      'specialJobsPercentage',
      'pieceworkPercentage',
    ]),
    PartialType(
      PickType(RegionDto, [
        'archived',
        'allowPayoutAmountEditing',
        'garageCostFixed',
        'dwHangingCostPerBoard',
        'dwFinishingCostPerBoard',
        'dwSprayingCostPerBoard',
        'highCeilingPerBoard',
        'screwInspectionPerBoard',
        'phaseStructureType',
        'dwpHangingCostPerBoard',
        'dwpFinishCostPerBoard',
        'dwpPrimeCostPerSqft',
        'dwpBump1CostPerBoard',
        'dwpTrim1CostPerSqft',
        'dwpInteriorPaintCostPerSqft',
        'dwpBump2CostPerBoard',
        'dwpTrim2CostPerSqft',
        'dwpFinalPaintCostPerSqft',
        'dwpBump3CostPerBoard',
        'dwpCMBluetapeCostPerSqft',
        'dwpFinalBluetapeCostPerSqft',
        'interiorOptionsPercentage',
        'exteriorOptionsPercentage',
        'trimOptionPercentage',
        'exteriorOnePercentage',
        'exteriorTwoPercentage',
      ]),
    ),
  )
  implements RegionCreatableInterface
{
  @ApiPropertyOptional({
    type: () => [RegionTimeWindowSeedDto],
    title: 'Time windows to seed',
    description:
      'H/O service time windows created together with the region. When omitted the default set (08-11, 11-14, 14-17) is seeded.',
  })
  @Expose()
  @IsOptional()
  @IsArray()
  @ArrayMaxSize(24)
  @ValidateNested({ each: true })
  @Type(() => RegionTimeWindowSeedDto)
  timeWindows?: RegionTimeWindowSeedDto[];
}
